<template>
  <FilterParent v-model="showFilters" module="Emergency Order">
    <template #filterContent>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-2">
          <MultiSelect hide-details="auto" :items="statusList" label="Status" clearable v-model="filterObject.status" />
        </v-col>
        <v-col cols="12" class="pa-2">
          <MultiSelect hide-details="auto" :items="stageList" label="Stage" clearable v-model="filterObject.stage" />
        </v-col>
        <v-col cols="12" class="pa-2">
          <MultiSelect hide-details="auto" :items="customerList" itemText="company_title" itemValue="id" label="Customer"
            clearable v-model="filterObject.customer" />
        </v-col>
        <v-col cols="12" class="pa-2">
          <MultiSelect hide-details="auto" :items="vendorList" itemText="company_title" itemValue="id" label="Vendor"
            clearable v-model="filterObject.vendor" />
        </v-col>
        <v-col cols="12" class="pa-2">
          <v-select
            hide-details="auto"
            :items="subHireOptions"
            label="Sub Hire"
            clearable
            outlined
            dense
            v-model="filterObject.is_sub_hire"
          />
        </v-col>
        <v-col cols="12" class="pa-2">
          <v-select
            hide-details="auto"
            :items="jobTypeList"
            label="Job Type"
            clearable
            outlined
            dense
            v-model="filterObject.job_type"
          />
        </v-col>
      </v-row>
    </template>

    <template #filterAction>
      <v-btn depressed color="secondary" @click="$emit('resetFilters'), (showFilters = false)">
        Reset
      </v-btn>
      <v-btn color="primary" class="ml-4" depressed @click="$emit('applyFilters'), (showFilters = false)">
        Apply
      </v-btn>
    </template>
  </FilterParent>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import FilterParent from "@/components/General/FilterParent.vue";

export default {
  components: {
    FilterParent,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bindingObject: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getCustomerList();
        this.getVendorList();
      }
    },
  },
  data() {
    return {
      customerList: [],
      vendorList: [],
      statusList: ["Created", "Active", "Completed"],
      stageList: ["Pickup", "Drop"],
      jobTypeList: ["Import", "Export", "FCL", "LCL", "Empty"],
      subHireOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
    };
  },
  computed: {
    showFilters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterObject: {
      get() {
        return this.bindingObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getCustomerList(params = {}) {
      this.$api.company
        .getCompanySelectList({ ...params, company_type: "Customer", limit: "all" })
        .then((res) => {
          this.customerList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getVendorList(params = {}) {
      this.$api.company
        .getCompanySelectList({ ...params, company_type: "Transporter", limit: "all" })
        .then((res) => {
          this.vendorList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
